import React, { useState, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { Menu, X, Phone, ArrowUpRight } from 'lucide-react';

const nav = [
  { to: '/', label: 'Accueil' },
  { to: '/solutions', label: 'Nos solutions' },
  { to: '/a-propos', label: 'À propos' },
  { to: '/contact', label: 'Contact' },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const loc = useLocation();

  useEffect(() => { setOpen(false); }, [loc.pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/95 backdrop-blur border-b border-gray-200 shadow-sm' : 'bg-white/80 backdrop-blur'}`}>
      <div className="max-w-7xl mx-auto px-5 lg:px-8 flex items-center justify-between h-20">
        <Link to="/" className="flex items-center gap-3 group">
          <img src="/logos/logo-main.png" alt="Suisse Energies Renouvelables" className="h-14 w-auto" />
        </Link>

        <nav className="hidden lg:flex items-center gap-9">
          {nav.map(n => (
            <NavLink key={n.to} to={n.to} end={n.to==='/'} className={({isActive}) => `text-[15px] font-medium relative transition-colors ${isActive ? 'text-[#125082]' : 'text-gray-700 hover:text-[#125082]'}`}>
              {({isActive}) => (
                <span className="relative">
                  {n.label}
                  {isActive && <span className="absolute -bottom-1.5 left-0 right-0 h-[2px] bg-[#80b23f]" />}
                </span>
              )}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-5">
          <a href="tel:+41225187155" className="flex items-center gap-2 text-sm text-gray-700 hover:text-[#125082] transition-colors">
            <Phone className="w-4 h-4" />
            <span className="font-medium">022 518 71 55</span>
          </a>
          <Link to="/contact" className="btn-primary inline-flex items-center gap-1.5 px-5 py-2.5 rounded-full text-sm font-medium">
            Demander un devis <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>

        <button className="lg:hidden p-2 text-gray-700" onClick={() => setOpen(!open)} aria-label="menu">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-gray-200">
          <div className="px-5 py-6 flex flex-col gap-4">
            {nav.map(n => (
              <NavLink key={n.to} to={n.to} end={n.to==='/'} className={({isActive}) => `text-base font-medium ${isActive ? 'text-[#125082]' : 'text-gray-700'}`}>{n.label}</NavLink>
            ))}
            <Link to="/contact" className="btn-primary inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full text-sm font-medium mt-3">
              Demander un devis <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
